<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="artificialIntelligence"
    class="m-edition-billing-artificial-intelligence"
  >
    <!-- Pestañas: mismas clases que la pantalla de Satelites (y que el submenu de productos en app-academy) -->
    <div class="m-edition-section-content-info">
      <div class="m-edition-section-content-info-submenu m-edition-section-content-info-submenu-products">
        <ul>
          <li
            v-for="tab in tabs"
            :key="tab.key"
          >
            <a
              href="#"
              :class="[currentTab === tab.key
                ? 'submenu-item-active submenu-item-active-products'
                : '']"
              @click.prevent="changeTab(tab.key)"
            >
              {{ $t(`mEditionBillingArtificialIntelligence.tabs.${tab.key}`) }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Un solo texto: el compilador descarta el espacio entre dos <span> y las frases quedaban pegadas -->
    <blockquote class="quote quote-products-primary quote-first">
      <p>
        {{ $t(`mEditionBillingArtificialIntelligence.quote.${currentTab}`) }}
        {{ $t('mEditionBillingArtificialIntelligence.quote.secondText') }}
      </p>
    </blockquote>

    <div class="display-flex-row-center space-between margin-top-large margin-bottom-large">
      <AtomButtonSecondary
        :button-secondary="buttonCreate"
        element="create"
        @executeMethod="openCreateModal"
      />
      <AtomInputPrimary
        v-model="search"
        placeholder="Buscar"
        name="search"
        type="text"
      />
    </div>

    <div
      v-if="showListLoadingState"
      key="listLoadingState"
    >
      <AtomLoadingSecondary/>
    </div>

    <div
      v-else-if="!searchedSatelites.length"
      key="empty"
      class="m-edition-billing-artificial-intelligence-empty"
    >
      <p>{{ $t(`mEditionBillingArtificialIntelligence.empty.${currentTab}`) }}</p>
      <small>{{ $t('mEditionBillingArtificialIntelligence.empty.action') }}</small>
    </div>

    <div
      v-else
      key="list"
      class="m-edition-billing-artificial-intelligence-list"
    >
      <a
        v-for="satelite in searchedSatelites"
        :key="satelite.id"
        class="m-edition-billing-artificial-intelligence-item"
        href="#"
        @click.prevent="openDetailModal(satelite)"
      >
        <MoleculeEditionBillingArtificialIntelligenceCard
          :modalidad="currentTab"
          :satelite="satelite"
        />
      </a>
    </div>

  </div>
</template>

<script>
import configApp from '@/config'

/*
 | Catalogo de Inteligencia Artificial: dos satelites distintos, cada uno en su pestaña.
 |  - mensual:  N creditos por mes; lo consumido vuelve a 0 el dia 1 (se vende por suscripcion).
 |  - creditos: un paquete de N creditos de un solo pago, que no vence ni se renueva.
 | Es una pantalla aparte y no una pestaña mas de Satelites porque aquella decide el tipo con
 | ternarios juedroop/evaluacion en cada archivo. Aca cada pestaña trae el sufijo de sus endpoints
 | (satelite.js) y se lo pasa a los modales, asi ningun archivo pregunta "si no es uno, es el otro".
 */
const TABS = [
  { key: 'mensual', sufijo: 'IaMensual' },
  { key: 'creditos', sufijo: 'IaCreditos' }
]

export default {
  name: 'MoleculeEditionBillingArtificialIntelligence',

  components: {
    MoleculeEditionBillingArtificialIntelligenceCard: () =>
      import('@/components/molecules/MoleculeEditionBillingArtificialIntelligenceCard')
  },

  data () {
    return {
      currentTab: 'mensual',
      satelites: {
        mensual: [],
        creditos: []
      },
      search: '',
      showListLoadingState: false,
      showLoadingState: true,
      tabs: TABS
    }
  },

  computed: {
    buttonCreate () {
      return {
        class: 'a-button-billing-secondary',
        component: '',
        icon: 'fas fa-plus',
        method: 'executeMethod',
        text: this.$t(`mEditionBillingArtificialIntelligence.buttonPrimary.${this.currentTab}`),
        type: 'button'
      }
    },

    // Se busca tambien por los creditos, con o sin punto de miles ("10000" o "10.000")
    searchedSatelites () {
      const lista = this.satelites[this.currentTab] || []

      if (!this.search) {
        return lista
      }

      const termino = this.search.toLowerCase()

      return lista.filter(satelite =>
        `${satelite.titulo} ${satelite.descripcion || ''} ${satelite.creditos} ${this.$utils.formatCredits(satelite.creditos)}`
          .toLowerCase()
          .includes(termino)
      )
    },

    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    // El modal avisa cuando termino: se refresca solo la pestaña que cambio
    updatedData () {
      if (this.$modal.methodToRun === 'readSatelitesIa') {
        this.readSatelites(this.currentTab)
      }

      if (this.$modal.methodToRun === 'toggleEstadoSateliteIa') {
        this.toggleEstado(this.$modal.element.satelite, this.$modal.element.nuevoEstado)
      }
    }
  },

  created () {
    // Con el flag apagado el item no esta en el menu; la URL directa tampoco muestra la pantalla
    if (configApp.droopInteligenciaArtificialHabilitado !== true) {
      this.$router.replace(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.satellites.subject')}`)

      return
    }

    this.readSatelites(this.currentTab, true)
  },

  methods: {
    changeTab (tab) {
      if (this.currentTab === tab) {
        return
      }

      this.currentTab = tab
      this.search = ''

      // Solo se pide la primera vez que se entra a la pestaña
      if (!this.satelites[tab].length) {
        this.readSatelites(tab)
      }
    },

    sufijoDe (tab) {
      return TABS.find(item => item.key === tab).sufijo
    },

    // Los datos que necesita cada modal: la pestaña decide la modalidad y los endpoints
    modalElement (satelite = null) {
      return {
        satelite: satelite,
        sufijo: this.sufijoDe(this.currentTab),
        tab: this.currentTab
      }
    },

    openCreateModal () {
      this.$modal.showModal('MoleculeEditionBillingArtificialIntelligenceModal', this.modalElement())
    },

    openDetailModal (satelite) {
      this.$modal.showModal('MoleculeEditionBillingArtificialIntelligenceModalDetail', this.modalElement(satelite))
    },

    readSatelites (tab, esPrimeraCarga = false) {
      this.showListLoadingState = !esPrimeraCarga

      this.$services.read('satelite', `readSatelites${this.sufijoDe(tab)}`)
        .then(response => {
          this.satelites = Object.assign({}, this.satelites, { [tab]: response.data })
        })
        .catch(() => {
          this.$alerts.pushAlert('mEditionBillingArtificialIntelligence', 'readSatelites', 'error', 'a-alert-danger')
        })
        .finally(() => {
          this.showListLoadingState = false
          this.showLoadingState = false
        })
    },

    // El PUT solo lleva "activo": los creditos no se editan despues del alta
    toggleEstado (satelite, nuevoEstado) {
      const data = { satelite: { activo: nuevoEstado } }

      this.$services.update('satelite', `updateSatelite${this.sufijoDe(this.currentTab)}`, data, [satelite.id])
        .then(() => {
          this.$modal.closeModal()
          this.$alerts.pushAlert('mEditionBillingArtificialIntelligence', 'updateSatelite', 'success', 'a-alert-success')
          this.readSatelites(this.currentTab)
        })
        .catch(() => {
          this.$alerts.pushAlert('mEditionBillingArtificialIntelligence', 'updateSatelite', 'error', 'a-alert-danger')
        })
    }
  }
}
</script>
